import React, { useEffect, useState } from "react";
import { Link } from "gatsby";
import axios from "axios";
import { KATALOG_API } from "../../consts/Endpoints";
import { PATH_T_CARD_DETAIL, PATH_H_CARD_DETAIL, PATH_A_CARD_DETAIL, PATH_N_CARD_DETAIL, PATH_PZ_CARD_DETAIL, PATH_IX_CARD_DETAIL, PATH_E_CARD_DETAIL } from "../../consts/RouterPaths";
import { tl } from "../FiyatGecmisi";
import "./digerMagazalar.css";

// Katalog mağaza kodları (teklif.magaza) → görünen ad / renk. Amazon fiyatı sitede gösterilmez (ortaklık koşulu).
const MAGAZA = {
  TRENDYOL: { ad: "Trendyol", renk: "#f27a1a" },
  HEPSIBURADA: { ad: "Hepsiburada", renk: "#ff6000" },
  AMAZON: { ad: "Amazon", renk: "#111827", fiyatGizle: true },
  N11: { ad: "n11", renk: "#5b2c83" },
  MEDIAMARKT: { ad: "MediaMarkt", renk: "#df0000" },
  VATAN: { ad: "Vatan Bilgisayar", renk: "#1d4ed8" },
  PAZARAMA: { ad: "Pazarama", renk: "#2541e6" },
  IDEFIX: { ad: "İdefix", renk: "#006bdc" },
};
// indirim aynasının kaynağı (mağaza veritabanı) → bizim indirim detay sayfası
const DETAY = { TRENDYOL: PATH_T_CARD_DETAIL, HEPSIBURADA: PATH_H_CARD_DETAIL, AMAZON: PATH_A_CARD_DETAIL, N11: PATH_N_CARD_DETAIL, ELEKTRONIK: PATH_E_CARD_DETAIL, PAZARAMA: PATH_PZ_CARD_DETAIL, IDEFIX: PATH_IX_CARD_DETAIL };
// site (SITELER anahtarı) → katalog mağaza kodu; elektronikte ürünün kendi mağazası
const SITE_KODU = { trendyol: "TRENDYOL", hepsiburada: "HEPSIBURADA", amazon: "AMAZON", n11: "N11", pazarama: "PAZARAMA", idefix: "IDEFIX" };

/**
 * "Diğer mağazalarda": katalog servisinin eşleştirdiği aynı ürün (marka + model + renk + kapasite) başka mağazalarda kaç
 * para, mağaza başına en ucuz teklif. Veri tarayıcıdan katalog servisine (detay verisinden bağımsız; gelmezse kutu görünmez).
 * Props: site, u (ürün / indirim kaydı: id, magaza), fiyat (bu sayfadaki fiyat, kıyas için; Amazon'da verilmez).
 */
export default function DigerMagazalar({ site, u, fiyat }) {
  const [liste, setListe] = useState(null);
  const magaza = site === "elektronik" ? u && u.magaza : SITE_KODU[site];
  const urunId = u && u.id != null ? String(u.id) : null;

  useEffect(() => {
    if (!KATALOG_API || !magaza || !urunId) return;
    let iptal = false;
    axios.get(KATALOG_API + "api/digerleri", { params: { magaza, urunId } })
      .then((r) => { if (!iptal) setListe(Array.isArray(r.data) ? r.data : []); })
      .catch(() => { if (!iptal) setListe([]); });
    return () => { iptal = true; };
  }, [magaza, urunId]);

  if (!liste || liste.length === 0) return null;
  return (
    <section className="dm" aria-label="Diğer mağazalarda">
      <h3 className="dm-baslik">Diğer mağazalarda</h3>
      <ul className="dm-liste">
        {liste.map((x) => {
          const m = MAGAZA[x.magaza] || { ad: x.magaza, renk: "#374151" };
          const ucuz = !m.fiyatGizle && fiyat && x.fiyat < fiyat * 0.99;
          return (
            <li key={x.magaza} className="dm-satir">
              <span className="dm-magaza" style={{ color: m.renk }}>{m.ad}</span>
              {x.indirim && DETAY[x.indirim.kaynak] && (
                <Link className="dm-indirim" to={DETAY[x.indirim.kaynak] + "?oid=" + x.indirim.oid}>%{x.indirim.oran} indirimde</Link>
              )}
              <span className={"dm-fiyat" + (ucuz ? " dm-ucuz" : "")}>
                {m.fiyatGizle ? "Fiyatı Amazon'da gör" : tl(x.fiyat)}
              </span>
              <a className="dm-git" href={x.url} target="_blank" rel="noopener noreferrer sponsored">{m.ad}'{m.ad === "n11" ? "de" : m.ad === "MediaMarkt" ? "ta" : m.ad === "İdefix" ? "te" : "da"} gör →</a>
            </li>
          );
        })}
      </ul>
      <p className="dm-not">Aynı ürünü (marka, model, renk ve kapasite) mağazalarda eşleştiriyoruz; fiyatlar son taramamıza göre.</p>
    </section>
  );
}
